import 'Magaele/clp_gpby/module.js';
import 'Magaele/tb_htrm/module.js';
import 'Magaele/nvb_gptb/module.js';
import 'Magaele/pp_ln/module.js';
import 'Magaele/mdl_lnls/module.js';
import 'Magaele/sf-lnse/module.js';
import 'Magaele/st_lnls/module.js';
import 'Magaele/int_lnls/module.js';
import 'Magaele/cy-ln/module.js';
import 'Magaele/btg_gpct/module.js';
import 'Magaele/st_lnht/module.js';





// WEBPACK FOOTER //
// ./entry/booking_script.entry.js